import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
// import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';
export const initialState = {
    loading: false,
    message: '',
    list:null,
}
export const LeaveListAll = createAsyncThunk('leave/list',async (data, { rejectWithValue }) => {
    try {
        const response = await masterService.getleave (data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})
export const LeaveSlice = createSlice({
    name: 'Leave',
    initialState,
    reducers: {
        LeaveListData: (state, action) => {
            state.loading = true
            state.list = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(LeaveListAll.pending, (state) => {
                state.loading = false
            })
            .addCase(LeaveListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})
export const {
    LeaveListData,
} = LeaveSlice.actions
export default LeaveSlice.reducer